/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RefreshTokenDto = {
    /**
     * Refresh token to use for generating a new access token. Optional — the server will also check the HTTP-only cookie. Use this field when cookies are unavailable (e.g. Swagger UI, mobile clients).
     */
    refresh_token?: string;
    /**
     * Device type. Used to determine token delivery method (cookie vs response body).
     */
    device_type?: RefreshTokenDto.device_type;
};
export namespace RefreshTokenDto {
    /**
     * Device type. Used to determine token delivery method (cookie vs response body).
     */
    export enum device_type {
        IOS = 'ios',
        ANDROID = 'android',
        WEB = 'web',
    }
}

